import { resolveClientDisplayInfo, resolveSiteLabel, sanitizeInstallationString, type InstallationIdentityLike } from "@/lib/installationContext";

export function DailyReportInstallationIdentity({ installation, className = "" }: {
  installation: InstallationIdentityLike;
  className?: string;
}) {
  const customer = resolveClientDisplayInfo(installation);
  const canonicalCustomer = sanitizeInstallationString(installation.canonicalCustomerName);
  const legacyCustomer = sanitizeInstallationString(installation.clientName);
  const siteName = resolveSiteLabel(installation);
  const installationCode = sanitizeInstallationString(installation.installationCode);
  const customerSource = canonicalCustomer ? "Cliente 360" : legacyCustomer ? "Nombre legacy" : "Sin identidad de cliente";

  return <p className={`flex min-w-0 flex-wrap gap-x-2 gap-y-1 break-words ${className}`.trim()} aria-label="Cliente, sede y número de instalación">
    <span><span className="font-medium">Cliente:</span> {customer.name}</span>
    {!canonicalCustomer && legacyCustomer && <span className="text-xs text-muted-foreground">({customerSource})</span>}
    <span><span className="font-medium">Sede:</span> {siteName || "Sede sin identificar"}</span>
    <span><span className="font-medium">N.º instalación:</span> {installationCode || "Instalación sin código"}</span>
  </p>;
}
